import { find, get } from 'lodash';

import { LoginConsts } from 'client/util/Constants';

import MfaApiResponseHandler from 'client/containers/Login/MfaApiResponseHandler';

// Routes
import { UserRoutes } from 'client/routes/RouteGenerator';
import MfaConstants from './MfaConstants';

const { resetPasswordUserForm } = UserRoutes;
const { responseMessages } = LoginConsts;
const {
  invalidCsrf,
  loginError,
  mfaExpired,
  mfaRequired,
  mfaUnavailableForPwdReset,
  passwordResetError,
} = responseMessages;

export const loginErrorHandler = (error = { response: { data: { message: loginError } } }) => {
  const { response } = error;
  const message = get(response, 'data.message', loginError);
  const factors = get(response, 'data.factors', []);

  if (message !== mfaRequired) {
    return Error(message);
  }

  return { factors };
};

const defaultPasswordResetError = { response: { data: { message: passwordResetError } } };

export const passwordResetErrorHandler = (error = defaultPasswordResetError) => {
  const { response } = error;
  const message = get(response, 'data.message', passwordResetError);
  const factors = get(response, 'data.factors', []);
  const challenge = get(response, 'data.challenge', undefined);
  const pwdResetToken = get(response, 'data.pwdResetToken', '');

  // TODO: Determine if we can reuse `mfaRequired` error message for password
  // reset attempts with no available factors.
  // See https://github.com/TheJumpCloud/SI/blob/master/routes/webui/systemusers.js#L361-L369
  if (message !== mfaRequired && message !== mfaUnavailableForPwdReset) {
    return Error(message);
  }

  return { factors, challenge, pwdResetToken };
};

export default {
  methods: {
    loginSuccessHandler(url) {
      this.redirect(url);
      return url;
    },

    passwordResetSuccessHandler(url) {
      this.redirect(url);
      return url;
    },

    setErrorMessage(message = loginError) {
      this.errorMessage = message;
      return this.errorMessage;
    },

    mfaRedirectHandler(mfa, options) {
      return this.$router.push(MfaApiResponseHandler(mfa, options));
    },

    mfaErrorRedirectHandler(factor, error, passwordResetData) {
      const confirmationCode = get(passwordResetData, 'confirmationCode');
      const errorMessage = get(error, 'response.data.message', passwordResetError);
      const statusCode = get(error, 'response.status');

      const redirectRules = [
        {
          key: 'invalidCsrf', // session timeout
          check: () => statusCode === 403 && errorMessage === invalidCsrf,
          handler: () => this.redirect(`${resetPasswordUserForm}&key=${confirmationCode}&error=${mfaExpired}`),
        },
        {
          key: 'forbidden', // exceed max totp attempts
          check: () => statusCode === 403 && errorMessage !== invalidCsrf,
          handler: () => this.vueRouteChange('Login', { error: errorMessage }),
        },
        {
          key: 'unauthorized', // duo 5 minute timeout
          check: () => factor === MfaConstants.mfaNames.duo && statusCode === 401,
          handler: () => this.redirect(`${resetPasswordUserForm}&key=${confirmationCode}&error=${mfaExpired}`),
        },
        {
          key: 'badRequest', // pwd doesn't meet org reqs
          check: () => statusCode === 400,
          handler: () => this.redirect(`${resetPasswordUserForm}&key=${confirmationCode}&error=${errorMessage}`),
        },
        {
          key: 'default',
          check: () => true,
          handler: () => this.setErrorMessage(errorMessage),
        },
      ];

      const { handler } = find(redirectRules, (rule) => rule.check());

      return handler;
    },
  },
};
